import { useLocation } from 'react-router';
import { TCreateOnsiteInterviewPageLocationState } from '../Types';

export const useSafeLocationState = () => {
  const { state } = useLocation() as Partial<{ state: TCreateOnsiteInterviewPageLocationState }>;

  const isAfterJobPosting = state?.isAfterJobPosting || false;

  return {
    isAfterJobPosting,
  } satisfies TCreateOnsiteInterviewPageLocationState;
};
